export default __webpack_public_path__ + "static/media/7.42.a003412c.jpg";